<app-base-modal
  [title]="'Удалить ссылку'"
>
  <div class="container">
    <form
      [formGroup]="formGroup"
      class="form-container"
    >
      @for (field of deleteProfilesBloggerFormFields; track $index) {
        <mat-form-field
          appearance="outline"
        >
          <mat-label>{{field.label}}</mat-label>
          <mat-select
            [formControlName]="field.fieldName"
          >
            @for (option of profiles; track $index) {
              <mat-option [value]="option.id">
                {{ option['url'] }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      }
    </form>
    <div class="buttons-container">
      <button
        mat-button
        color="primary"
        [disabled]="!isValid()"
        (click)="handleProfileBloggerDelete()"
      >
        Удалить
      </button>
      <button
        mat-button
        color="warn"
        (click)="closeDialog('cancel')"
      >
        Отменить
      </button>
    </div>
  </div>
</app-base-modal>
